import * as React from 'react';
import * as classNames from 'classnames';
import { observer } from 'mobx-react';
import { MobileNavigationItem } from './MobileNavigationItem';
import { NavigationProps } from '../';
import { NavigationItem, NavigationRoot } from '../../../../models';
import DonateButton from '../../../Common/DonateButton';
import './style.css';

export interface MobileNavigationState {
  /* empty */
}

@observer
export class MobileNavigation extends React.Component<
  NavigationProps,
  MobileNavigationState
> {
  render() {
    const { headerItems, items } = this.props;

    let navMenuItems = this.getMenuItems(
      // Also show header items in nav on mobile
      headerItems.concat(items)
    );

    navMenuItems = this.addNavItemToMenu(
      <li key="Donate" className="mobile-navigation-item">
        <DonateButton className="donate-form edge-of-play-link mobile-navigation-link" />
      </li>,
      2,
      navMenuItems
    );

    const { expanded } = this.props;

    const classes = classNames({
      expanded: expanded,
      'mobile-navigation': true
    });

    return (
      <nav className={classes}>
        <ul className="mobile-navigation-list">{navMenuItems}</ul>
      </nav>
    );
  }

  private getMenuItems = (items: Array<NavigationItem>): Array<JSX.Element> => {
    const elements: Array<JSX.Element> = [];
    const { mobileExpandedItems, onToggleMobileItem } = this.props;

    for (let index = 0; index < items.length; index++) {
      const item: NavigationItem = items[index];
      const rootItem = item as NavigationRoot;

      if (rootItem.isOverflowItem) {
        elements.splice(
          elements.length,
          0,
          ...this.getMenuItems(rootItem.children)
        );

        continue;
      }

      const expanded: boolean = !!(
        mobileExpandedItems && mobileExpandedItems.indexOf(rootItem) >= 0
      );

      elements.push(
        <MobileNavigationItem
          key={item.name}
          item={item}
          expanded={expanded}
          onToggleMobileItem={onToggleMobileItem}
        />
      );
    }

    return elements;
  };

  private addNavItemToMenu = (
    item: JSX.Element,
    index: number,
    elements: Array<JSX.Element>
  ): Array<JSX.Element> => {
    elements.splice(index, 0, item);

    return elements;
  };
}

export default MobileNavigation;



// WEBPACK FOOTER //
// ./src/app/components/App/Navigation/MobileNavigation/index.tsx